import { Box, IconButton, Popover } from "@mui/material"
import styles from "./AdvancedFilter.module.css"
import CloseIcon from "@mui/icons-material/Close"
import { ReactNode, useMemo } from "react"
import AdvancedFilter from "./AdvancedFilter"
import { GridColDef } from "@mui/x-data-grid"
import { observer } from "mobx-react"
import { ModuleName } from "@/store/AppStore.types"
import AppStore from "@/store/AppStore"
import { ExtendedGridColDef } from "../../../interface/InfiniteTable"

type TFilterPopover = {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: any // (event: Event, reason: "backdropClick" | "escapeKeyDown" | "manual") => void
  columns: ExtendedGridColDef[]
  moduleName?: ModuleName
  onChangeAdvFilter: Function
  sortBy?: keyof ExtendedGridColDef
}

const FilterPopover = (props: TFilterPopover) => {
  const { open, anchorEl, onClose, columns, moduleName, onChangeAdvFilter, sortBy } = props

  // This is needed as Hydration may not work if this component is rendered on first page
  const isPrefill = moduleName ? AppStore.isStoreHydrated() : true

  const columnData = useMemo(() => {
    if (!sortBy) return columns

    return [...columns].sort((a, b) => {
      const aValue = a[sortBy]
      const bValue = b[sortBy]

      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue)
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return aValue - bValue
      }

      return 0
    })
  }, [columns, sortBy])

  return (
    <Popover
      open={isPrefill && open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      className={styles.FilerPopoverRoot}
      slotProps={{
        paper: {
          className: styles.FilerPopover,
        },
      }}
    >
      <Box className={styles.FilterContainer}>
        <Box className={styles.Header}>
          <Box className={styles.Title}>Advanced Filters</Box>
          <IconButton className={styles.CloseIcon} onClick={(e) => onClose(e, "manual")}>
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
        <Box className={styles.FilterChildren}>
          {anchorEl && <AdvancedFilter columns={columnData} moduleName={moduleName} onChangeAdvFilter={onChangeAdvFilter} />}
        </Box>
      </Box>
    </Popover>
  )
}

export default observer(FilterPopover)
